

const UserRoleMap = {
  0: '所有',
  1: '运营',
  2: '商务主管',
  3: '商务',
  4: '博主',
  5: '审核',
  6: '代发',
  7: '财务',
}


const UserRoleOptions =[]
for (let k in UserRoleMap) {
  UserRoleOptions.push({
    value: k,
    text: UserRoleMap[k],
  })
}

const UserRoleALL = 0
const UserRoleOperator = 1
const UserRoleDirectorManager = 2
const UserRoleDirector = 3
const UserRoleBlogger = 4
const UserRoleAuditor = 5
const UserRoleDaifa = 6
const UserRoleCaiwu = 7


const UserStatusMap = {
  '-1': '未激活',
  '0': '待审核',
  '1': '已启用',
  '2': '已拒绝',
  '3': '已冻结',
}

const ToolIDOptions = [
  {
    label: '无', value: ''
  },
  {
    label: "AI修图", value: "omni"
  },{
    label: "AI换装", value: "clothes"
  },{
    label: "换发型", value: "hair"
  },{
    label: "换背景", value: "background"
  },{
    label: "AI替换", value: "addon"
  },{
    label: "AI打光", value: "light"
  },{
    label: "AI消除", value: "remove"
  },{
    label: "相机效果", value: "camera"
  },{
    label: "AI美体", value: "physique"
  },{
    label: "天空", value: "sky"
  },{
    label: "萌宠", value: "pets"
  },{
    label: "纹身", value: "tattoo"
  },{
    label: "特效写真", value: "portrait"
  },{
    label: "扩图", value: "expand"
  },{
    label: "贴图", value: "stick"
  },{
    label: "换脸", value: "faceswap"
  },{
    label: "图转视频", value: "image2video"
  },{
    label: "证件照", value: "idphoto"
  },{
    label: "美甲", value: "nailart"
  },{
    label: "美颜", value: "beauty"
  },{
    label: "AI相机", value: "aicamera"
  },{
    label: "首饰", value: "jewelry"
  },{
      label: "AI改文字", value: "words"
  },{
      label: "Retake", value: "takephoto"
  },{
      label: "Vibe", value: "vibedit"
  },{
      label: "合照", value: "couple_photo"
  },{
      label: "全家福", value: "family_portrait"
  },{
      label: "表情包", value: "emoticons"
  },{
      label: "AI妆容", value: "makeup"
  },
  {
      label: "AI发丝", value: "hair_strands"
  },
  {
      label: "滤镜", value: "filter"
  },
  {
      label: "拍照角度", value: "reframe"
  },
  
  // 视频相关的放到后面，其余的放到前面
  {
      label: "P视频", value: "video_editing"
  },{
      label: "视频换装", value: "video_cloth"
  },{
      label: "视频增加", value: "video_addon"
  },{
      label: "视频替换", value: "video_replace"
  },{
      label: "视频消除", value: "video_remove"
  },{
      label:"视频换背景", value: "video_background"
  },{
      label: "视频提升画质", value: "video_upscale"
  }
]

var ToolNames = {
}
for (let k in ToolIDOptions) {
  ToolNames[ToolIDOptions[k].value] = ToolIDOptions[k].label
}

const StyleIdOptions =  [{
  label: "无", value: '',
},{
  label: "AI替换", value: '0'
},
{
  label: "AI增加", value: '1'
}, {
  label: "AI消除", value: '2'
}, {
  label: "AI抠图", value: '3'
}, {
  label: "AI换背景", value: '4'
}, 
// {
//   label: "AI换背景垫图", value: '44'
// }, 
{
  label: "一键高清", value: '5'
}, {
  label: "一键扩图", value: '6'
}, {
  label: "AI补光", value: '7'
}, {
  label: "背景模糊", value: '8'
}, {
  label: "照片上色", value: '9'
}, {
  label: "AI证件照", value: '10'
}, {
  label: "海马证件照", value: '11'
}, {
  label: "写真", value: '12'
}, {
  label: "AI换装", value: '13'
}, {
  label: "AI滤镜", value: '14'
}, {
  label: "AI融合", value: '15'
}, {
  label: "去水印", value: '16'
},{
  label: "商品换背景", value: '19'
},{
  label: "换脸", value: '22'
},{
  label: "视频换脸", value: '53'
},{
  label: "万能改图（豆包）", value: '20'
},{
  label: "万能改图(爆改)", value: '24'
},{
  label: "Kontext Pro API", value: '25'
},{
  label: "换发型 Kontext+Lora", value: '28'
},{
  label: "Kontext Dev", value: '29'
},{
  label: "Nano-Banana(API)", value: '30'
}, {
  label: "Jimeng3.0(API)", value: '31'
},{
  label: "Seedream4.0(API)", value: '32'
}, {
  label: "Seedream 4.5(API)", value: '44'
},{
  label: "Seedream 5.0(API)", value: '61'
},{
  label: "Banana Nailart", value: '33'
},{
  label: "百度高清", value: '34'
},{
  label: "证件照(Nano-Banana)", value: '35'
},{
  label: "海外Seedream 4.0", value: '36'
},{
  label: "首饰 comfyui", value: '37'
},
{
  label: "换背景(参考图qwen)", value: '38'
},
{
  label: "换背景(提示词qwen)", value: '39'
},{
  label: "换背景(参考图fluxpro)", value: '47'
},
{
  label: "美甲lora", value: '40'
},
{
  label: "Nano-Banana-Pro(API)", value: '41'
},
{
  label: "Qwen Image Relight", value: '42'
},
{
  label: "Qwen Image Edit Plus(API)", value: '43'
},
{
  label: "aliyun wan 2.5", value: '45'
},{
  label: "aliyun wan 2.6", value: '48'
},
// {
//   label: "Google-Banana-Pro", value: '46'
// },
{
  label: "识别人脸", value: '21'
},{
  label: "识别鞋子", value: '23'
},{
  label: "识别发型", value: '17'
},{
  label: "识别路人", value: '18'
},{
  label: "本地贴图", value: '50'
},{
  label: "图生视频", value: '90'
},{
  label: "美体 Seedream", value: '51'
},{
  label: "美体 Lora", value: '52'
},{
  label: "去除路人(工作流seedream)", value: '54'
},{
  label: "美手(qwen)", value: '55'
},
{
  label: "美颜(工作流seedream)", value: '57'
},
{
  label: "表情包(九宫格)", value: '58'
},
{
  label: "美发(工作流banana)", value: '59'
},{
  label: "美妆(工作流banana)", value: '60'
},{
  label: "锁骨", value: '63'
},{
  label: "男厚涂", value: '64'
},{
  label: "女厚涂（亮晶晶）", value: '65'
},{
  label: "女厚涂V2", value: '66'
},{
  label: "瘦腿", value: '67'
},{
  label: "GPTImage2", value: '75'
},{
  label: "发丝(qwen)", value: '76'
},{
  label: "瘦腰(qwen)", value: '77'
},{
  label: "Wan2.7", value: 'wan27-direct'
},{
  label: "Picwiz-clothe", value: 'picwiz-clothe'
},{
  label: "Qwen-omni", value: '79'
},{
  label: "刘海", value: '80'
},{
  label: "丰胸", value: '82'
},{
  label: "多角度", value: '81'
},{
  label: "姿势迁移", value: '83'
},{
  label: "发根染色", value: '84'
},
]

var StyleNames = {
}
for (let k in StyleIdOptions) {
  StyleNames[StyleIdOptions[k].value] = `${StyleIdOptions[k].label}(${StyleIdOptions[k].value})`
}

const SubTypeOptions =  [{
  label: "无", value: '',
},{
  label: "消除路人", value: 'remove_passer'
},{
  label: "替换发型", value: 'replace_hair'
},{
  label: "替换发型(omni)", value: 'replace_hair_omni'
},{
  label: "替换发色", value: 'replace_haircolor'
},{
  label: "增加纹身", value: 'add_tattoo'
},{
  label: "增加配饰", value: 'add_accessory'
},{
  label: "增加美甲", value: 'add_manicure'
},{
  label: "增加(omni)", value: 'add_prompt'
},{
  label: "换鞋", value: 'replace_shoes'
},{
  label: "消除特效", value: 'remove_effects'
},{
  label: "新风格化", value: 'stylization'
},{
  label: "贴图背景", value: 'stick_image_background'
},{
  label: "贴图素材", value: 'stick_image_element'
},

]

var SubTypeNames = {
}
for (let k in SubTypeOptions) {
  SubTypeNames[SubTypeOptions[k].value] = SubTypeOptions[k].label
}


const TaskStyleGroupOptions = [
  {
    label:"Comfyui",
    options:[
      {
        label: "万能替换", value: '0',
      },
      {
        label: "增加", value: '1', disabled: true
      },
      {
        label: "消除", value: '2'
      },{
        label: "抠图", value: '3'
      }, 
      {
        label: "换背景", value: '4',
      },
      {
        label: "高清", value: '5',
      },
      {
        label: "扩图", value: '6'
      },{
        label: "补光", value: '7', disabled: true
      }, {
        label: "背景模糊", value: '8', disabled: true
      }, {
        label: "照片上色", value: '9', disabled: true
      }, {
        label: "证件照", value: '10', disabled: true
      }, {
        label: "海马证件照", value: '11', disabled: true
      }, {
        label: "写真", value: '12', disabled: true
      }, 
      {
        label: "换装", value: '13'
      },{
        label: "AI滤镜", value: '14', disabled: true
      }, {
        label: "AI融合", value: '15', disabled: true
      },{
        label: "商品换背景", value: '19', disabled: true
      },{
        label: "换脸", value: '22'
      },{
        label: "视频换脸", value: '53'
      },{
        label: "换发型(kontext)", value: '28'
      },{
        label: "kontext-dev", value: '29'
      },{
        label: "证件照(banana)", value: '35'
      },{
        label: "首饰", value: '37'
      },
      {
        label: "换背景(参考图 qwen)", value: '38'
      },
      {
        label: "换背景(提示词 qwen)", value: '39'
      },{
        label: "换背景(参考图fluxpro)", value: '47'
      },{
        label: "美甲(banana)", value: '33',
      },{
        label: "美甲(lora)", value: '40', disabled: false
      },{
        label: "打光(qwen) ", value: '42'
      },{
        label: "图生视频", value: '90'
      },{
        label: "贴图", value: '50'
      },{
        label: "美体(Seedream)", value: '51'
      },{
        label: "美体(Lora)", value: '52'
      },{
        label: "去除路人(工作流seedream)", value: '54'
      },{
        label: "美手(qwen)", value: '55'
      },
      {
        label: "美颜(工作流seedream)", value: '57'
      },{
        label: "表情包(九宫格)", value: '58', disabled: true
      },{
        label: "美发(工作流banana)", value: '59', disabled: true
      },{
        label: "美妆(工作流banana)", value: '60'
      },{
        label: "锁骨", value: '63'
      },{
        label: "男厚涂", value: '64'
      },{
        label: "女厚涂（亮晶晶）", value: '65'
      },{
        label: "女厚涂V2", value: '66'
      },{
        label: "瘦腿", value: '67'
      },{
        label: "发丝(qwen)", value: '76'
      },{
        label: "瘦腰(qwen)", value: '77'
      },{
        label: "刘海", value: '80'
      },{
        label: "丰胸", value: '82'
      },{
        label: "多角度", value: '81'
      },{
        label: "姿势迁移", value: '83'
      },{
        label: "发根染色", value: '84'
      }
    ]
  },{
    label: "Seedream",
    options:[
      {
        label: "Jimeng 3.0", value: '31'
      },{
        label: "Seedream 4.0", value: '32'
      },
      {
        label: "Seedream 4.5", value: '44'
      },{
        label: "Seedream 5.0", value: '61'
      },{
        label: "海外Seedream 4.0", value: '36'
      }
    ]
  },{
    label: "Gemini",
    options:[
      {
        label: "nano-banana", value: '30'
      },{
        label: "nano-banana-pro(thrid)", value: '41'
      },
      {
        label: "nano-banana-pro(official)", value: '46', disabled: true
      },
      {
        label: "nano-banana-2(thrid)", value: '62'
      },
    ]
  },{
    label: "GPT",
    options:[
      {
        label: "gpt-image-2", value: '75'
      }
    ]
  },{
    label: "阿里万象",
    options: [
      {
        label: "Qwen Image Edit Plus", value: '43'
      },
      {
        label: "aliyun wan 2.5", value: '45'
      },{
        label: "aliyun wan 2.6", value: '48'
      },{
        label: "aliyun wan 2.7", value: 'wan27-direct'
      },{
        label: "Qwen-omni", value: '79'
      },
    ]
  },{
    label: "算法备案",
    options: [{
        label: "picwiz-clothe", value: 'picwiz-clothe'
      },
    ]
  },{
    label: "Kontext",
    options: [
      {
        label: "Kontext Pro", value: '25'
      },
    ]
  },{
    label: "Other",
    options: [
      {
        label: "Omni(聚合)", value: '20'
      },{
        label: "万能改图(爆改)", value: '24'
      },
      {
        label: "百度高清", value: '34'
      },{
        label: "去水印", value: '16'
      },
    ]
  },{
    label: "Detect",
    options: [
    {
      label: "识别人脸", value: '21'
    },{
      label: "识别鞋子", value: '23'
    },{
      label: "识别发型", value: '17'
    },{
      label: "识别路人", value: '18'
    }
    ]
  },{
    label: "Video",
    options: [
    {
      label: "视频高清", value: '68'
    },{
      label: "P视频", value: '69'
    },{
      label: "视频增加", value: '70'
    },{
      label: "视频替换", value: '71'
    },{
      label: "视频消除", value: '72'
    },{
      label: "视频换装", value: '73'
    },{
      label: "视频换背景", value: '74'
    },{
      label: "图转视频-爱诗", value: 'pixverse-img2video'
    }
    ]
  }
]


let TaskStyleGroupOptionsAll = []
for (let group of TaskStyleGroupOptions) {
  // item.disabled = false
  let options = []
  for (let item of group.options) {
    options.push({
      ...item,
      disabled: false,
    })
  }
  TaskStyleGroupOptionsAll.push({
    label: group.label,
    options,
  })
}

// Deprecated 暂时不用了，用上面的 `TaskStyleGroupOptions`
const StyleFlowOptions =  [{
  label: "无", value: '',
},{
  label: "万能替换 Comfy v2", value: '0'
},{
  label: "增加 Comfy v1", value: '1'
}, {
  label: "消除 xpic", value: '2'
}, {
  label: "换背景 Comfy", value: '4'
},{
  label: "扩图 Comfy", value: '6'
}, {
  label: "换装 Comfy", value: '13'
},{
  label: "去水印 Textin[API]", value: '16'
}, {
  label: "豆包", value: '20'
},{
  label: "换脸", value: '22'
},{
  label: "Kontext Pro[API]", value: '25'
},{
  label: "换发型(Kontext Dev)", value: '28'
},{
  label: "kontext Dev", value: '29'
}, {
  label: "Gemini Nano-Banana[API]", value: '30'
},{
  label: "Jimeng 3.0[API]", value: '31'
},{
  label: "Seedream 4.0[API]", value: '32'
},
{
  label: "Seedream 4.5 (API)", value: '44'
},
{
  label: "Banana Nailart", value: '33'
},{
  label: "百度高清[API]", value: '34'
},{
  label: "证件照(Nano-Banana)", value: '35'
},{
  label: "海外Seedream 4.0[API]", value: '36'
},{
  label: "首饰 comfyui", value: '37'
},
{
  label: "换背景(参考图qwen)", value: '38'
},
{
  label: "换背景(提示词qwen)", value: '39'
},{
  label: "换背景(参考图fluxpro)", value: '47'
},{
  label: "美甲lora", value: '40'
},
{
  label: "Nano-Banana-Pro[API]", value: '41'
},
{
  label: "Qwen Image Relight", value: '42'
},
{
  label: "Qwen Image Edit Plus[API]", value: '43'
},
{
  label: "aliyun wan 2.5", value: '45'
},{
  label: "aliyun wan 2.6", value: '48'
},
// {
//   label: "Google-Banana-Pro", value: '46'
// },
{
  label: "图生视频 comfyui", value: '90'
},{
  label: "贴图", value: '50'
},{
  label: "美体 Seedream", value: '51'
},{
  label: "美体 Lora", value: '52'
},{
  label: "美手qwen", value: '55'
},
]

var StyleFlowNames = {
}
for (let k in TaskStyleGroupOptions) {
  for (let i in TaskStyleGroupOptions[k].options) {
    StyleFlowNames[TaskStyleGroupOptions[k].options[i].value] = `${TaskStyleGroupOptions[k].options[i].label}(${TaskStyleGroupOptions[k].options[i].value})`
  }
}


var NationCodes = [
  { value: "CN", label: "中国",},
  { value: "US", label: "美国",},
  { value: "JP", label: "日本",},
  { value: "KR", label: "韩国",},
  { value: "GB", label: "英国",},
  { value: "DE", label: "德国",},
  { value: "FR", label: "法国",},
  { value: "IT", label: "意大利",},
  { value: "ES", label: "西班牙",},
  { value: "BR", label: "巴西",},
  { value: "AD", label: "安道尔共和国",},
{ value: "AE", label: "阿拉伯联合酋长国",},
{ value: "AF", label: "阿富汗",},
{ value: "AG", label: "安提瓜和巴布达",},
{ value: "AI", label: "安圭拉岛",},
{ value: "AL", label: "阿尔巴尼亚",},
{ value: "AM", label: "亚美尼亚",},
{ value: "AO", label: "安哥拉",},
{ value: "AR", label: "阿根廷",},
{ value: "AT", label: "奥地利",},
{ value: "AU", label: "澳大利亚",},
{ value: "AZ", label: "阿塞拜疆",},
{ value: "BB", label: "巴巴多斯",},
{ value: "BD", label: "孟加拉国",},
{ value: "BE", label: "比利时",},
{ value: "BF", label: "布基纳法索",},
{ value: "BG", label: "保加利亚",},
{ value: "BH", label: "巴林",},
{ value: "BI", label: "布隆迪",},
{ value: "BJ", label: "贝宁",},
{ value: "BL", label: "巴勒斯坦",},
{ value: "BM", label: "百慕大群岛",},
{ value: "BN", label: "文莱",},
{ value: "BO", label: "玻利维亚",},
{ value: "BR", label: "巴西",},
{ value: "BS", label: "巴哈马",},
{ value: "BW", label: "博茨瓦纳",},
{ value: "BY", label: "白俄罗斯",},
{ value: "BZ", label: "伯利兹",},
{ value: "CA", label: "加拿大",},
{ value: "CF", label: "中非共和国",},
{ value: "CG", label: "刚果",},
{ value: "CH", label: "瑞士",},
{ value: "CK", label: "库克群岛",},
{ value: "CL", label: "智利",},
{ value: "CM", label: "喀麦隆",},
{ value: "CO", label: "哥伦比亚",},
{ value: "CR", label: "哥斯达黎加",},
{ value: "CU", label: "古巴",},
{ value: "CY", label: "塞浦路斯",},
{ value: "CZ", label: "捷克",},
{ value: "DE", label: "德国",},
{ value: "DJ", label: "吉布提",},
{ value: "DK", label: "丹麦",},
{ value: "DO", label: "多米尼加共和国",},
{ value: "DZ", label: "阿尔及利亚",},
{ value: "EC", label: "厄瓜多尔",},
{ value: "EE", label: "爱沙尼亚",},
{ value: "EG", label: "埃及",},
{ value: "ES", label: "西班牙",},
{ value: "ET", label: "埃塞俄比亚",},
{ value: "FI", label: "芬兰",},
{ value: "FJ", label: "斐济",},
{ value: "FR", label: "法国",},
{ value: "GA", label: "加蓬",},
{ value: "GB", label: "英国",},
{ value: "GD", label: "格林纳达",},
{ value: "GE", label: "格鲁吉亚",},
{ value: "GF", label: "法属圭亚那",},
{ value: "GH", label: "加纳",},
{ value: "GI", label: "直布罗陀",},
{ value: "GM", label: "冈比亚",},
{ value: "GN", label: "几内亚",},
{ value: "GR", label: "希腊",},
{ value: "GT", label: "危地马拉",},
{ value: "GU", label: "关岛",},
{ value: "GY", label: "圭亚那",},
{ value: "HK", label: "中国香港特别行政区",},
{ value: "HN", label: "洪都拉斯",},
{ value: "HT", label: "海地",},
{ value: "HU", label: "匈牙利",},
{ value: "ID", label: "印度尼西亚",},
{ value: "IE", label: "爱尔兰",},
{ value: "IL", label: "以色列",},
{ value: "IN", label: "印度",},
{ value: "IQ", label: "伊拉克",},
{ value: "IR", label: "伊朗",},
{ value: "IS", label: "冰岛",},
{ value: "IT", label: "意大利",},
{ value: "JM", label: "牙买加",},
{ value: "JO", label: "约旦",},
{ value: "JP", label: "日本",},
{ value: "KE", label: "肯尼亚",},
{ value: "KG", label: "吉尔吉斯坦",},
{ value: "KH", label: "柬埔寨",},
{ value: "KP", label: "朝鲜",},
{ value: "KR", label: "韩国",},
{ value: "KT", label: "科特迪瓦共和国",},
{ value: "KW", label: "科威特",},
{ value: "KZ", label: "哈萨克斯坦",},
{ value: "LA", label: "老挝",},
{ value: "LB", label: "黎巴嫩",},
{ value: "LC", label: "圣卢西亚",},
{ value: "LI", label: "列支敦士登",},
{ value: "LK", label: "斯里兰卡",},
{ value: "LR", label: "利比里亚",},
{ value: "LS", label: "莱索托",},
{ value: "LT", label: "立陶宛",},
{ value: "LU", label: "卢森堡",},
{ value: "LV", label: "拉脱维亚",},
{ value: "LY", label: "利比亚",},
{ value: "MA", label: "摩洛哥",},
{ value: "MC", label: "摩纳哥",},
{ value: "MD", label: "摩尔多瓦",},
{ value: "MG", label: "马达加斯加",},
{ value: "ML", label: "马里",},
{ value: "MM", label: "缅甸",},
{ value: "MN", label: "蒙古",},
{ value: "MO", label: "中国澳门特别行政区",},
{ value: "MS", label: "蒙特塞拉特岛",},
{ value: "MT", label: "马耳他",},
{ value: "MU", label: "毛里求斯",},
{ value: "MV", label: "马尔代夫",},
{ value: "MW", label: "马拉维",},
{ value: "MX", label: "墨西哥",},
{ value: "MY", label: "马来西亚",},
{ value: "MZ", label: "莫桑比克",},
{ value: "NA", label: "纳米比亚",},
{ value: "NE", label: "尼日尔",},
{ value: "NG", label: "尼日利亚",},
{ value: "NI", label: "尼加拉瓜",},
{ value: "NL", label: "荷兰",},
{ value: "NO", label: "挪威",},
{ value: "NP", label: "尼泊尔",},
{ value: "NR", label: "瑙鲁",},
{ value: "NZ", label: "新西兰",},
{ value: "OM", label: "阿曼",},
{ value: "PA", label: "巴拿马",},
{ value: "PE", label: "秘鲁",},
{ value: "PF", label: "法属玻利尼西亚",},
{ value: "PG", label: "巴布亚新几内亚",},
{ value: "PH", label: "菲律宾",},
{ value: "PK", label: "巴基斯坦",},
{ value: "PL", label: "波兰",},
{ value: "PR", label: "波多黎各",},
{ value: "PT", label: "葡萄牙",},
{ value: "PY", label: "巴拉圭",},
{ value: "QA", label: "卡塔尔",},
{ value: "RO", label: "罗马尼亚",},
{ value: "RU", label: "俄罗斯",},
{ value: "SA", label: "沙特阿拉伯",},
{ value: "SB", label: "所罗门群岛",},
{ value: "SC", label: "塞舌尔",},
{ value: "SD", label: "苏丹",},
{ value: "SE", label: "瑞典",},
{ value: "SG", label: "新加坡",},
{ value: "SI", label: "斯洛文尼亚",},
{ value: "SK", label: "斯洛伐克",},
{ value: "SL", label: "塞拉利昂",},
{ value: "SM", label: "圣马力诺",},
{ value: "SN", label: "塞内加尔",},
{ value: "SO", label: "索马里",},
{ value: "SR", label: "苏里南",},
{ value: "ST", label: "圣多美和普林西比",},
{ value: "SV", label: "萨尔瓦多",},
{ value: "SY", label: "叙利亚",},
{ value: "SZ", label: "斯威士兰",},
{ value: "TD", label: "乍得",},
{ value: "TG", label: "多哥",},
{ value: "TH", label: "泰国",},
{ value: "TJ", label: "塔吉克斯坦",},
{ value: "TM", label: "土库曼斯坦",},
{ value: "TN", label: "突尼斯",},
{ value: "TO", label: "汤加",},
{ value: "TR", label: "土耳其",},
{ value: "TT", label: "特立尼达和多巴哥",},
{ value: "TW", label: "中国台湾省",},
{ value: "TZ", label: "坦桑尼亚",},
{ value: "UA", label: "乌克兰",},
{ value: "UG", label: "乌干达",},
{ value: "US", label: "美国",},
{ value: "UY", label: "乌拉圭",},
{ value: "UZ", label: "乌兹别克斯坦",},
{ value: "VC", label: "圣文森特岛",},
{ value: "VE", label: "委内瑞拉",},
{ value: "VN", label: "越南",},
{ value: "YE", label: "也门",},
{ value: "YU", label: "南斯拉夫",},
{ value: "ZA", label: "南非",},
{ value: "ZM", label: "赞比亚",},
{ value: "ZR", label: "扎伊尔",},
{ value: "ZW", label: "津巴布韦",},
]

var Operators = {
  37: "Jeff",
  // 3171067: "宝顺",
  1204599: "道贤",
  862515: "ian",
  // 326526: "Treelu",
  905722: "Oliver",
  15:"傲洋",
  6: "Mark",
  // 22: "Violam",
  10: "Sudi",
  18: "Floria", // 董丞宸
  12: "Kairo", // 徐钊
  // 53: "Liuyang",
  244986: "Chenqiyan",
  244348: "Yuanyining",
  548814: "Liyu",
  618115:"Liuxiaoran",
  961628: "Fengchuhan",
  3454935: "Wuyuxuan",
  617984: "Shenxinjie",
  3025012: "Mafei",
  617454: "刘朵云",
  1300636: "刘紫怡",
  // 5102244: "陈颜",
  // 4607387: "李文青",
  5190830: "余奕成",
  4378250: "冉欣垚",
  2928502: "Yuxi",
  6406968: "Yuxi",
  6552178: "YU",
  5948451: "陈欣伊",
  5234909: "赵辉",
  6005641: "兰雪瑜",
  5539868: "刘庚桥",
  5272118: "曾雨寒",
  5322485: "傅雨菲",
  5475789: "王瑜琦",
  4745041: "先海燕",
  4908034: "崔津凡",

}

const ExecutorTopics =   [
{ topic: "aitools.add", name: "增加"},
{ topic: "aitools.add.doubao", name: "增加(doubao)"},
{ topic: "aitools.add.manicure", name: "增加美甲"},
{ topic: "aitools.remove", name: "消除"},
{ topic: "aitools.replace", name: "替换"},
{ topic: "aitools.clothes", name: "换装"},
{ topic: "aitools.image2video", name: "图生视频"},
{ topic: "aitools.cutout", name: "抠图"},
{ topic: "aitools.expand", name: "扩图"},
{ topic: "aitools.faceswap", name: "换脸"},
{ topic: "aitools.faceswap.video", name: "视频换脸"},
{ topic: "aitools.fliter", name: "滤镜"},
{ topic: "aitools.haima", name: "海马体"},
{ topic: "aitools.hd", name: "高清"},
{ topic: "aitools.idphoto", name: "证件照"},
{ topic: "aitools.other", name: "其他"},
{ topic: "aitools.portrait", name: "写真"},
{ topic: "aitools.recolor", name: "上色"},
{ topic: "aitools.nailart", name: "Banana 美甲"},
{ topic: "aitools.replace.haircolor", name: "替换发色"},
{ topic: "aitools.replace.hairstyle", name: "替换发型"},
{ topic: "aitools.replace_background", name: "换背景"},
{ topic: "aitools.style", name: "风格化"},
{ topic: "aitools.stylization", name: "新版风格化"},
{ topic: "anything.doubao", name: "doubao"},
{ topic: "anything.doubao.hair", name: "doubao 换发型"},
{ topic: "omni.community", name: "doubao 社区"},
{ topic: "omni.higgs_banana", name: "higgs_banana"},
{ topic: "aidetect.face", name: "识别人脸"},
{ topic: "aidetect.hairstyle", name: "识别发型"},
{ topic: "aidetect.passer", name: "识别路人"},
{ topic: "aidetect.shoes", name: "识别鞋子"},
{ topic: "aitools.add.add_accessory", name: "增加首饰"},
{ topic: "aitools.add.add_tattoo", name: "增加纹身"},
{ topic: "kontext.lora.hair", name: "换发型 Kontext"},
{ topic: "kontext.dev", name: "Kontext Dev"},
{ topic: "banana.idphoto", name: "证件照(Nano-Banana)"},
{ topic: "aitools.jewelry", name: "增加首饰"},
{ topic: "aitools.replacebg.reference", name: "换背景(参考图qwen)"},
{ topic: "aitools.replacebg.prompt", name: "换背景(提示词qwen)"},
{ topic: "aitools.naillora", name: "美甲lora"},
{ topic: "aitools.qwen.relight", name: "Qwen-Relight"},
{ topic: "aitools.replacebg.fluxpro_refer", name: "换背景(参考图fluxpro)"},
{
  topic: "aitools.physique", name: "美体",
},{
  topic: "aitools.remove.passerby", name: "去除路人(工作流seedream)",
},{
  topic: "aitools.qwen.beautyhand", name: "美手(qwen)",
},{
  topic: "aitools.seedream.beautyface", name: "美颜(工作流seedream)",
},{
  topic: "aitools.emoticons", name: "表情包(九宫格)",
},{
  topic: "aitools.beautyhair", name: "美发(工作流banana)",
},{
  topic: "aitools.beautymakeup", name: "美妆(工作流banana)",
},{
  topic: "aitools.collarbone", name: "锁骨",
},{
  topic: "aitools.boyhoutu", name: "男厚涂",
},{
  topic: "aitools.girlhoutu", name: "女厚涂（亮晶晶）",
},{
  topic: "aitools.girlhoutuV2", name: "女厚涂V2",
},{
  topic: "aitools.shoutui", name: "瘦腿",
},{
  topic: "aitools.hairsty1", name: "发丝(qwen)",
},{
  topic: "aitools.video.upscale", name: "视频高清",
},{
  topic: "aitools.shouyao", name: "瘦腰",
},{
  topic: "aitools.qwen.omni", name: "Qwen-omni",
},{
  topic: "aitools.hairbangs", name: "刘海",
},{
  topic: "aitools.hugebreast", name: "丰胸",
},{
  topic: "aitools.multiangle", name: "多角度",
},{
  topic: "aitools.posetrans", name: "姿势迁移",
},{
  topic: "aitools.hairroot", name: "发根染色",
}
]

export  {
  UserRoleMap,
  UserRoleALL,
  UserRoleOperator,
  UserRoleDirectorManager,
  UserRoleDirector,
  UserRoleBlogger,
  UserRoleAuditor,
  UserRoleOptions,
  UserStatusMap,
  UserRoleDaifa,
  UserRoleCaiwu,
  StyleIdOptions,
  SubTypeOptions,
  ToolIDOptions,
  ToolNames,
  StyleNames,
  StyleFlowNames,
  SubTypeNames,
  NationCodes,
  Operators,
  ExecutorTopics,
  TaskStyleGroupOptions,
  TaskStyleGroupOptionsAll,
}
